export const sourceMap = {

  // -----------------------------
  // News
  // -----------------------------

  "Canadian Lawyer": {
    id: "ca_news_canadian_lawyer",
    slug: "canadian-lawyer",
  },
  "Canadian Bar Association, British Columbia": {
    id: "ca_news_cbabc",
    slug: "cba-bc",
  },
  "Law Society of Alberta": {
    id: "ca_news_lsab",
    slug: "law-society-ab",
  },
  "Law Society of BC": {
    id: "ca_news_lsbc",
    slug: "law-society-bc",
  },
  "Law Society of Newfoundland and Labrador": {
    id: "ca_news_lsnl",
    slug: "law-society-nl",
  },
  "National Magazine": {
    id: "ca_news_national_magazine",
    slug: "national-magazine",
  },
  "Ontario Bar Association": {
    id: "ca_news_oba",
    slug: "ontario-bar-association",
  },
  "Slaw": {
    id: "ca_news_slaw",
    slug: "slaw",
  },

  // -----------------------------
  // Blogs
  // -----------------------------

  "Bennett Jones Insights": {
    id: "ca_blog_bennett_jones",
    slug: "bennett-jones-insights",
  },
  "BLG Insights": {
    id: "ca_blog_blg",
    slug: "blg-insights",
  },
  "Blakes Insights": {
    id: "ca_blog_blakes",
    slug: "blakes-insights",
  },
  "Davies Insights": {
    id: "ca_blog_davies",
    slug: "davies-insights",
  },
  "Double Aspect": {
    id: "ca_blog_doubleAspect",
    slug: "double-aspect",
  },
  "Gowling Insights": {
    id: "ca_blog_gowling",
    slug: "gowling-insights",
  },
  "Miller Thomson Insights": {
    id: "ca_blog_miller_thomson",
    slug: "miller-thomson-insights",
  },
  "Osler Insights": {
    id: "ca_blog_osler",
    slug: "osler-insights",
  },
  "Slater Vecchio": {
    id: "ca_blog_slater_vecchio",
    slug: "slater-vecchio",
  },

  // -----------------------------
  // Journals
  // -----------------------------

  "Osgoode Hall Law Journal": {
    id: "ca_journal_ohlj",
    slug: "osgoode-hall-law-journal",
  },
  "UBC Law Journal": {
    id: "ca_journal_ubclr",
    slug: "ubc-law-journal",
  },

}

export const slugMap = Object.values(sourceMap).reduce((acc, s) => {
  acc[s.slug] = s
  return acc
}, {})